/**
 * Seeded `com.NotificationType` ids, pinned by PBI 56950 and asserted API-side against the seed.
 * The ids are the contract; the `name` strings are display data and must not be filtered on.
 */
export enum NotificationTypeId {
  Email = 1,
  Phone = 2,
  PortalMessage = 3,
  TextMessage = 4,
}
